import { SvgIcon, SvgIconProps } from '@mui/material';

export default function StarIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 25 25" fill="none">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7274 1.19965L16.0734 7.82865L22.5134 8.46665C22.8264 8.49267 23.0957 8.69841 23.2032 8.99361C23.3106 9.2888 23.2365 9.61952 23.0134 9.84065L17.7134 15.0936L19.6784 22.2316C19.7605 22.5409 19.6536 22.8696 19.4052 23.0713C19.1568 23.2731 18.8132 23.3104 18.5274 23.1667L11.9984 19.9337L5.47836 23.1627C5.19248 23.3064 4.84888 23.2691 4.60052 23.0673C4.35216 22.8656 4.24524 22.5369 4.32736 22.2276L6.29236 15.0897L0.988358 9.83665C0.765238 9.61552 0.691132 9.2848 0.798554 8.9896C0.905977 8.69441 1.1753 8.48867 1.48836 8.46265L7.92836 7.82465L11.2694 1.19965C11.4095 0.926035 11.691 0.753906 11.9984 0.753906C12.3058 0.753906 12.5873 0.926035 12.7274 1.19965Z"
          fill="#67707E"
          stroke="#67707E"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
